import React from 'react';
import { FiSearch, FiBell, FiZap } from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const TopBar = () => {
  return (
    <header className="h-16 bg-slate-950/80 backdrop-blur-md border-b border-slate-800 flex items-center justify-between px-6 sticky top-0 z-20">
      <div className="flex items-center bg-slate-900 border border-slate-700 rounded-full px-4 py-1.5 w-64 md:w-96 focus-within:border-blue-500/50 focus-within:ring-1 focus-within:ring-blue-500/50 transition-all">
        <SafeIcon icon={FiSearch} className="text-slate-500 mr-2" />
        <input 
          type="text" 
          placeholder="Search candidates, roles, skills..." 
          className="bg-transparent border-none outline-none text-sm text-slate-300 w-full placeholder-slate-600"
        />
      </div>

      <div className="flex items-center gap-4">
        <button className="relative p-2 text-slate-400 hover:text-blue-400 transition-colors">
          <SafeIcon icon={FiBell} className="text-xl" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-green-500 rounded-full shadow-[0_0_8px_rgba(34,197,94,0.8)]"></span>
        </button>
        <div className="flex items-center gap-2 pl-4 border-l border-slate-800 cursor-pointer group">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-indigo-900 flex items-center justify-center border border-blue-400/30 group-hover:border-blue-400 transition-colors">
            <SafeIcon icon={FiZap} className="text-white text-sm" />
          </div>
          <div className="hidden md:block text-sm">
            <p className="text-slate-200 font-medium leading-tight">Admin User</p>
            <p className="text-slate-500 text-xs">Recruiting Lead</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopBar;